// ==================== 基础属性常量 ====================
export const BASE_HP = 1000;
export const HP_PER_VIT = 50;
export const BASE_MP = 500;
export const MP_PER_INT = 30;
export const BASE_ATK = 50;
export const ATK_PER_STR = 5;
export const BASE_SPELL = 50;
export const SPELL_PER_INT = 4;
export const BASE_DEF = 20;
export const DEF_PER_VIT = 3;
export const BASE_RES = 15;
export const RES_PER_INT = 2;
export const BASE_CRIT = 0.05;
export const CRIT_PER_AGI = 0.0015;
export const BASE_CDMG = 1.5;
export const BASE_SPEED = 5.0;
// ==================== 战斗常量 ====================
export const DEF_CONSTANT = 400; // 减伤公式常量
export const PVP_DAMAGE_RATIO = 0.7; // PVP 伤害系数（PVP 伤害 = 70%）
export const MELEE_RANGE = 2.5; // 近战普攻范围
export const RESPAWN_TIME = 5; // 复活时间（秒）
// ==================== 红名系统 ====================
export const SIN_PER_KILL = 100; // 每次杀白名增加罪恶值
export const SIN_DECAY_INTERVAL = 600; // 罪恶值衰减间隔（秒）
export const SIN_DECAY_AMOUNT = 10; // 每次衰减量
// ==================== 强化系统 ====================
export const MAX_ENHANCE_LEVEL = 15;
export const ENHANCE_RATES = [
    1.0, 1.0, 1.0, 1.0, 1.0, // +1 ~ +5: 100%
    0.7, 0.7, 0.7, 0.7, 0.7, // +6 ~ +10: 70%
    0.4, 0.4, 0.4, 0.4, 0.4, // +11 ~ +15: 40%
];
export const ENHANCE_STAT_BONUS = 0.05; // 每级 +5% 基础属性
// ==================== 等级经验 ====================
export const MAX_LEVEL = 50;
export function expForLevel(level) {
    if (level <= 10)
        return level * 100;
    if (level <= 20)
        return 1000 + (level - 10) * 400;
    if (level <= 30)
        return 5000 + (level - 20) * 1500;
    if (level <= 40)
        return 20000 + (level - 30) * 5000;
    return 70000 + (level - 40) * 10000;
}
// ==================== 网络常量 ====================
export const TICK_RATE = 20; // 服务器 tick (20fps)
export const MOVE_SYNC_RATE = 100; // 移动同步间隔 (ms)
export const MAX_PLAYERS_PER_ROOM = 50;
export const AOI_RANGE = 50; // 兴趣范围半径 (米)
// ==================== 地图常量 ====================
export const GRAVITY = -9.81;
export const PLAYER_HEIGHT = 1.8;
